module.exports = __webpack_public_path__ + "img/gastos_mobile.63201fad.svg";